export const EMAIL_REGEX = /[\w-]+@([\w-]+\.)+[\w-]+/;
export const AUSTRALIAN_PHONE_REGEX = /^(?:\+?61|0)?(?:\([2-478]\)|[2-478]|4)\d{8}$/;
